import { Container, Flex } from "@chakra-ui/react";
import LogoutIcon from "./icons/LogoutIcon";
import { useConnectedUser } from "../hooks/user.hooks";
import { logout } from "../mutations/auth.mutations";
import { unsetToken } from "../client";
import { useNavigate } from "react-router-dom";
import UserAvatar from "./UserAvatar";
import { useQueryClient } from "react-query";
import { useCenters } from "../hooks/centers.hooks";

function SidebarFooter() {
  const user = useConnectedUser();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { setCurrentCenter } = useCenters();

  if (!user) {
    return <></>;
  }
  return (
    <Container borderTop="solid 1px #E2E8F0" mb="10px">
      <Flex justifyContent="space-between" mt="30px">
        <UserAvatar userId={user.id}></UserAvatar>
        <LogoutIcon
          color="brand.700"
          w="20px"
          h="20px"
          onClick={() => {
            logout();
            unsetToken();
            queryClient.removeQueries();
            setCurrentCenter(null)
            navigate("/login");
          }}
        />
      </Flex>
    </Container>
  );
}

export default SidebarFooter;
